/* istanbul ignore next */
const gaMiddleware = store => next => action => {
  try {
    if (
      action.type === "@@router/LOCATION_CHANGE" &&
      store.getState().router.location
    ) {
      const newRoute = `${action.payload.pathname}${action.payload.search}`
      const oldRoute = `${store.getState().router.location.pathname}${
        store.getState().router.location.search
      }`
      /* istanbul ignore next */
      if (oldRoute !== newRoute)
        /* istanbul ignore next */
        window.gtag("event", "page_view", { page_location: newRoute })
    }
  } catch (e) {
    /* istanbul ignore next */
    console.warn(`Error in gaMiddleware: ${e}`)
  } finally {
    next(action)
  }
}

export default gaMiddleware
